/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Legend_GwInputs */



/**
* | output |
* | --- |
* | "Game wins" |
*
* @param {Score_Legend_GwInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const score_legend_gw = /** @type {((inputs?: Score_Legend_GwInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Legend_GwInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Victoires de partie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Victorias de partida")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vitórias de partida")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vittorie di partita")
	return /** @type {LocalizedString} */ ("Game wins")
});